export default "__VITE_ASSET__Bh1EwiPi__"